import React, { useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import Flex from 'components/common/Flex';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import { Image } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import { getSize } from 'helpers/utils';
import PropTypes from 'prop-types';
import SimpleBar from 'simplebar-react';

const ImageUploader = ({ onFilesAdded, onFileRemoved, files, progress }) => {
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/*': ['.jpeg', '.png', '.jpg']
    },
    onDrop: onFilesAdded
  });

  useEffect(() => {
    console.log(progress);
  }, [progress]);

  return (
    <>
      <div {...getRootProps({ className: 'dropzone-area py-6' })}>
        <input {...getInputProps()} />
        <Flex justifyContent="center">
          <img src={cloudUpload} alt="" width={25} className="me-2" />
          <p className="fs-9 mb-0 text-700">Drop your images here</p>
        </Flex>
      </div>
      <SimpleBar style={{ maxHeight: '12rem' }} className="mt-1">
        {files.map(file => (
          <Flex
            alignItems="center"
            className="py-3 border-bottom btn-reveal-trigger"
            key={file.id}
          >
            <Image
              rounded
              width={40}
              height={40}
              src={file.preview}
              alt={file.path}
            />
            <Flex
              justifyContent="between"
              alignItems="center"
              className="ms-3 flex-1"
            >
              <div>
                <h6>{file.path}</h6>
                <Flex className="position-relative" alignItems="center">
                  <p className="mb-0 fs-10 text-400 line-height-1">
                    <strong>{getSize(file.size)}</strong>
                  </p>
                </Flex>
              </div>
            </Flex>
            <IconButton
              variant="light"
              icon="trash"
              className="mb-1"
              iconAlign="right"
              transform="shrink-3"
              onClick={() => onFileRemoved(file)}
            ></IconButton>
          </Flex>
        ))}
      </SimpleBar>
    </>
  );
};

ImageUploader.propTypes = {
  onFilesAdded: PropTypes.func.isRequired,
  onFileRemoved: PropTypes.func.isRequired,
  files: PropTypes.array.isRequired,
  progress: PropTypes.number.isRequired
};

export default ImageUploader;
